import React from "react";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import { Box, Grid, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useHistory, useLocation } from "react-router-dom";
import InstaColors, {
  ExpandButton,
  fontFamily,
  reviewScreenButtonWithColor,
  reviewScreenButtonWithOutColor,
  useSharedValue,
} from "../Constants/constants";
import CloseIcon from "@mui/icons-material/Close";
// Minus icon
import OrganizationChartManager from "../../tree_views/horizontal_view";
import { extractedColumnNames } from "../list";
import { getUserIdFromLocalStorage } from "../../API_Endpoints/APIEndpoints";
import SecureDocumentViewer from "../WorkLoade_File_Import/SecureDocumentViewer";

const borderStyle = {
  width: "250px",
  marginLeft: "20px",
  backgroundColor: "white",
  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2aa7e0",
  },
  "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2aa7e0",
  },
  "&.Mui-focused .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "#2aa7e0",
  },
};

export default function DisplayExtractionView() {
  const { searchValue } = useSharedValue();
  const { treeView, handleTreeView } = useSharedValue();

  const { dataRows } = useSharedValue();
  const [activeView, setActiveView] = useState({
    id: null,
    visualize: false,
    extraction: false,
    original: false,
  });
  const location = useLocation();
  let row = location.state?.row;
  let someValue = location.state?.someValue;
  let rooValue = location.state?.rootValue;
  let iSEdit = location.state?.iSEdit;
  let accurancyValue = location.state?.accuracyPercentage;
  let dataExtraction = JSON.parse(location.state?.datatable);
  let dataTree = JSON.parse(location.state?.dataTree);
  const { isMenuOpen } = useSharedValue();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModel] = useState(false);
  const [selectUpdateRow, setSelectUpdateRow] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [columnName, setColumnName] = useState(null);
  const [rowIndex, setRowIndex] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [businessUnits, setBusinessUnits] = React.useState([]);
  const [popupHeight, setPopupHeight] = useState(560);
  const [viewHeight, setViewHeight] = useState(520);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isDisplayView, setIsDisplayView] = useState(false);
  const [selectedView, setSelectedView] = useState(false);
  const [isVisualView, setIsVisualView] = useState(false);
  const [isOriginalView, setIsOriginalView] = useState(false);
  const [email, setEmail] = React.useState("Select");
  const [editingRowIndex, setEditingRowIndex] = useState(null);
  const [editingCell, setEditingCell] = useState({ rowId: null, field: null });
  const [type, setType] = React.useState("");
  const [reason, setReason] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [editValue, setEditValue] = useState("");
  const [updateQuestion, setUpdateQuestion] = useState("");
  const [treeData, setTreeData] = useState([]);
  const [selectedCheckbox, setSelectedCheckbox] = useState(null);
  const [extractedData, setExtractedData] = useState(null);
  const [extractionColumns, setExtractionColumns] = useState([]);
  const [addNote, setAddNote] = useState("");
  const [saveSum, setSaveSum] = useState(0);
  let totalAllocation = "100%";
  const [accuracy, setAccuracy] = useState("");
  const [businessUnitName, setBusinessUnitName] = useState("");
  const [runValidation, setRunValidation] = useState("");
  const [selectSheet, setSelectSheet] = useState("Business Entities");
  const history = useHistory();
  const typeList = [
    "Select",
    "Additional Information Only",
    "Outstanding Action",
    "Escalated",
    "Approved",
    "Rejected",
  ];
  const rejectionList = [
    "Select Reject Reason",
    "Rejection Reason 1",
    "Rejection Reason 2",
    "Rejection Reason 3",
  ];
  const approveList = [
    "Select Approve Reason",
    "Approve Reason 1",
    "Approve Reason 2",
    "Approve Reason 3",
  ];
  const [usersEmailsList, setUsersEmailsList] = useState(["Select"]);
  const [extractedValidatedata, setExtractedValidateData] = useState([]);
  const [emailedDate, setEmailedDate] = useState(null);
  const { numberOfSelectedRows, updateRowNumberOfPages } = useSharedValue();
  const [startIndex, setStartIndex] = useState(0); // Initial rows per page value
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const [endIndex, setEndIndex] = useState(5);
  const [dataValidation, setDataValidation] = useState([]);
  const [isConfirmationPopup, setIsConfirmationPopup] = useState(false);
  const [isChangesSaved, setIsChangesSaved] = useState(false);
  const [onClickValue, setOnClickValue] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(50);
  const MIN_ZOOM = 25;
  const MAX_ZOOM = 400;
  const ZOOM_STEP = 25;

  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + ZOOM_STEP, MAX_ZOOM));
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - ZOOM_STEP, MIN_ZOOM));
  };

  const [rows, setRows] = useState([]);
  const [extractionRows, setextractionRows] = React.useState([]);

  const [extractionTopRows, setextractionTopRows] = React.useState([]);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const formatDate = (value) => {
    const date = new Date(value);

    const month = date.toLocaleString("en-US", { month: "short" });
    const day = date.toLocaleString("en-US", { day: "2-digit" });
    const year = date.toLocaleString("en-US", { year: "numeric" });
    const hour24 = date.getHours();
    const minute = date.getMinutes();

    const amPm = hour24 < 12 ? "am" : "pm";

    const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
    const formattedHour = hour12 < 10 ? `0${hour12}` : hour12;
    const formattedMinute = minute < 10 ? `0${minute}` : minute;

    return `${month} ${day}, ${year} ${formattedHour}:${formattedMinute} ${amPm}`;
  };
  const handlePopupHeight = (value, viewId, id) => {
    setIsExpanded(value);
    if (value === true) {
      setPopupHeight(window.innerHeight);
      setViewHeight(window.innerHeight);
      setIsOriginalView(activeView.original);

      if (id === 1) {
        setIsVisualView(activeView.extraction);
        setActiveView({
          id: id,
          visualize: true,
          extraction: false,
          original: false,
        });
      }
      if (id === 2) {
        setIsVisualView(activeView.visualize);
        setActiveView({
          id: id,
          visualize: false,
          extraction: true,
          original: false,
        });
      }
    } else {
      setPopupHeight(560);
      setViewHeight(520);

      if (id === 1) {
        setActiveView({
          id: id,
          visualize: true,
          extraction: isVisualView,
          original: isOriginalView,
        });
      }
      if (id === 2) {
        setActiveView({
          id: id,
          visualize: isVisualView,
          extraction: true,
          original: isOriginalView,
        });
      }
    }
  };

  React.useEffect(() => {
    if (someValue !== null && someValue !== "") {
      setSelectedRowId(someValue);

      setTreeData(dataTree);
      if (dataExtraction.length > 0) {
        const firstRowKeys = Object.keys(dataExtraction[0]);

        // Create columnData array with column names
        const columnData = firstRowKeys.map((key) => ({
          field: key,
          headerName: key.toUpperCase(),
        }));
        setExtractionColumns(columnData);
        setextractionRows(dataExtraction);
      }
      setSelectedRowId(someValue);
      setActiveView({
        id: row.fileImportId,
        visualize: true,
        extraction: true,
        original: true,
      });
    }
    someValue = null;
  }, [someValue]);

  // Function to handle row deletion
  const handleDeleteClickRow = (index) => {
    // Create a copy of the data array
    const newData = [...extractionRows];
    // Use splice to remove the element at the specified index
    newData.splice(index, 1);
    // Update the state with the new array
    setextractionRows(newData);
  };

  const handleSaveClickChanges = (fileImportId, filename) => {
    setIsChangesSaved(false);
    setIsLoading(true);

    const updatedRowData = {
      ...rows.find((item) => item.fileImportId === fileImportId),
      dataExtraction: JSON.stringify(extractionRows), // Stringify the list
    };

    const formData = new FormData();
    formData.append("filename", filename);

    formData.append("validateData", updatedRowData.dataExtraction);

    formData.append("parentName", treeData[0].name);

    const url = `https://whsai.complytaxforms.com/saveEditedTableData`;

    fetch(url, {
      method: "POST",
      body: formData, // Include the FormData object as the request body
    })
      .then((response) => {
        setIsLoading(false); // Consider moving this line inside the .then and .catch to ensure it's always executed last

        if (response.ok) {
          response
            .json() // Call .json() once to parse JSON body
            .then((data) => {
              const updatedRowData = {
                ...rows.find((item) => item.fileImportId === fileImportId),
                dataVisualisation: JSON.stringify(data.treeData),
                dataExtraction: JSON.stringify(extractionRows),
                dataValidation: JSON.stringify(data.extractedValidationData),
              };
              setRows((prevRows) =>
                prevRows.map((row) =>
                  row.fileImportId === updatedRowData.fileImportId ? updatedRowData : row
                )
              );
              setextractionTopRows([
                {
                  numberOfLines: 1,
                  allocations: data.treeData[0].allocation,
                  matchManual: accurancyValue,
                },
              ]);
              setExtractedValidateData(data.extractedValidationData);
              setTreeData(data.treeData);

              fetch(`https://euswhsbe.azurewebsites.net/FileData/ImportFiles`, {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
                },
                body: JSON.stringify(updatedRowData),
                // Include the FormData object as the request body
              }).then((response) => {
                if (response) {
                  history.push(rooValue);
                  setIsLoading(false);
                }
              });

              // Update state with new tree data
            });
        } else {
          console.error("HTTP error:", response.statusText); // Log or handle HTTP error
        }
      })
      .catch((error) => {
        setIsLoading(false); // Ensure loading state is reset even on fetch errors
        console.error("Fetch error:", error); // Log or handle fetch error
      });
  };
  const handleSave = () => {
    setSaveSum(saveSum + 1);
    setIsChangesSaved(true);

    const updatedExtractedValidateData = [...extractionRows];

    // Update the value in the extractedValidateData array for the specified row and column
    updatedExtractedValidateData[editingRowIndex][editingCell.field] = editValue;
    setextractionRows(updatedExtractedValidateData);

    setIsModalOpen(false);
  };

  // Overlay component
  const LoadingOverlay = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        backgroundColor: "rgba(255, 255, 255, 0.5)", // You can adjust the color and opacity as needed
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress style={{ color: "#2aa7e0", marginLeft: 30 }} />

        {/* <p style={{ marginTop: '10px', color: '#2aa7e0', }}>Saving changes....</p> */}
      </div>
    </div>
  );

  useEffect(() => {
    const handlePopups = () => {
      if (
        isViewOpen === false &&
        isChangesSaved === true &&
        runValidation === false &&
        saveSum > 0
      ) {
        setIsViewOpen(true);
        setIsConfirmationPopup(true);
      } else {
        setIsConfirmationPopup(false);
      }
    };
    handlePopups();
  }, [isChangesSaved, onClickValue, saveSum, isViewOpen]);

  const updateTreeDataAndExtractionRows = (fileImportId, fileName) => {
    // Loop through each item in treeData
    const targetRow = rows.find((row) => row.fileImportId === fileImportId);
    const targetRowIndex = rows.findIndex((row) => row.fileImportId === fileImportId);
    let updatedExtractionRows = [...extractionRows];

    if (targetRow) {
      JSON.parse(targetRow.dataVisualisation).forEach((treeItem, treeIndex) => {
        // // Update the corresponding row in extractionRows
        if (treeIndex >= 1) {
          const oldName = treeItem.name;
          const oldAllocation = treeItem.allocation;
          const oldFormType = treeItem.formType;

          for (const key in updatedExtractionRows[treeIndex - 1]) {
            if (updatedExtractionRows[treeIndex - 1][key] === oldName) {
              updatedExtractionRows[treeIndex - 1][key] = treeData[treeIndex].name;
            }
            if (updatedExtractionRows[treeIndex - 1][key] === oldAllocation) {
              updatedExtractionRows[treeIndex - 1][key] = treeData[treeIndex].allocation;
            }
            if (updatedExtractionRows[treeIndex - 1][key] === oldFormType) {
              updatedExtractionRows[treeIndex - 1][key] = treeData[treeIndex]["formType"];
            }
          }
        }
      });
      // Update targetRow with new dataVisualisation
      targetRow.dataVisualisation = JSON.stringify(treeData);
      targetRow.dataExtraction = JSON.stringify(updatedExtractionRows);
      setextractionRows(updatedExtractionRows);
      handleSaveClickChanges(fileImportId, fileName);
    }
  };

  function getFormTypeColor(formType) {
    switch (formType) {
      case "W-9":
        return "#FFD700"; // Golden color
      case "W-8BEN":
        return "#90EE90"; // Light green
      case "W-8BEN-E":
        return "#FFA07A"; // Light salmon
      case "W-8ECI":
        return "#FF6347"; // Tomato
      case "W-8IMY":
        return "#87CEEB"; // Sky blue
      case "W-8EXP":
        return "#FFC0CB"; // Pink
      default:
        return "#7DF9FF"; // Default color
    }
  }

  // Update the src URL dynamically based on the zoom level
  const pdfSrc = `https://eformapi.complytaxforms.com/WHS/${row.fileImportId}.pdf#zoom=${zoomLevel}`;

  const handleUpdateView = (event) => {
    handleTreeView(event.target.value);
    // if (treeView == 'horizontal') {
    //     handleTreeView('vertical');
    // } else {
    //     handleTreeView('horizontal')
    // }
  };

  return (
    <div
      id="extraction_Review"
      style={{
        display: "flex",
        flexDirection: "column",
        marginLeft: 20,
        marginTop: 20,

        width: isMenuOpen === true ? "calc(100vw - 280px)" : "calc(100vw - 128px)",
        marginRight: 20,
        height: "calc(100vh - 92px)",
      }}
    >
      {(isDisplayView === false || selectedView === "Extraction") && (
        <div
          style={{
            width: "100%",
            background: InstaColors.white,
            overflowX: "hidden",
            paddingLeft: 20,
            paddingRight: 20,
            borderRadius: 11,
            display: "flex",
            flexDirection: "column",
            height: isExpanded === true ? "100%" : "50%",
            // marginBottom: 10,
          }}
        >
          {isExpanded === false && (
            <div
              style={{
                flex: 1,
                backgroundColor: "transparent",
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  style={reviewScreenButtonWithOutColor(100, { value: true })}
                  onClick={() => {
                    history.push(rooValue);
                  }}
                >
                  Return
                </Button>
              </div>
            </div>
          )}
          <div
            style={{
              width: "100%",
              flexDirection: "column",
              display: "flex",
              overflow: "hidden",
              justifyContent: "flex-start",
              height: "100%",
              alignItems: "center",
            }}
          >
            {someValue === row.fileImportId && (
              <>
                <div
                  style={{
                    // background: 'linear-gradient(235deg, #06243B, #05243C, #03467A)',
                    background: "white",
                    width: "100%",
                    height: "100%",
                    overflow: "auto",
                    // scrollbarWidth: 'thin', // For Firefox
                    // scrollbarColor: ' #EAF6FC #EAF6FC',
                  }}
                >
                  {isExpanded && <div style={{ marginTop: 20 }}></div>}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      width: "100%",
                      marginBottom: 5,
                    }}
                  >
                    <span
                      style={{
                        color: "black",
                        fontWeight: 500,
                        fontSize: 15,
                        width: 140,
                        fontFamily: fontFamily,
                      }}
                    >
                      Extraction View
                    </span>
                    <Box
                      display="flex"
                      justifyContent="flex-end"
                      alignItems="center"
                      // marginTop={5}
                      style={{ width: "100%", backgroundColor: "white" }}
                    >
                      {/* Row with titles and values */}
                      <Grid container spacing={2} justifyContent="flex-end">
                        {extractionTopRows.map((row, index) => (
                          <Grid item key={index}>
                            <Box display="flex" flexDirection="row" alignItems="center">
                              {extractedColumnNames.map((column) => (
                                <Box key={column.field} textAlign="center" mb={1}>
                                  {/* Title */}
                                  <Typography
                                    // variant="subtitle2"
                                    style={{
                                      color: "black",
                                      fontSize: 14,
                                      color: InstaColors.primary,
                                      fontWeight: 400,
                                      marginRight: 8,
                                      fontFamily: fontFamily,
                                      marginTop: 10,
                                    }}
                                  >
                                    {column.header} :{" "}
                                    <span
                                      style={{
                                        color: "black",
                                        fontSize: 14,
                                        color: InstaColors.primary,
                                        fontWeight: 300,
                                        marginRight: 8,
                                        fontFamily: fontFamily,
                                        marginTop: 10,
                                      }}
                                    >
                                      {" "}
                                      {row[column.field]}
                                    </span>
                                  </Typography>
                                  {/* Value */}
                                </Box>
                              ))}
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                    {isExpanded === true ? (
                      <CloseIcon
                        style={{
                          fontSize: 24,
                          color: InstaColors.primary,
                          marginRight: 0,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setIsExpanded(false);
                          setSelectedView(null);
                          setIsDisplayView(false);
                        }}
                      />
                    ) : (
                      <ExpandButton
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setIsExpanded(true);
                          setSelectedView("Extraction");
                          setIsDisplayView(true);
                        }}
                      />
                    )}
                  </div>
                  {isExpanded && <div style={{ marginBottom: 20 }}></div>}
                  <TableContainer
                    component={Paper}
                    style={{
                      backgroundColor: "transparent",
                      // Set minimum height to 350px
                      padding: 0,
                      margin: 0,
                      overflow: "auto",
                      border: "none",
                      boxShadow: "none",
                      borderRadius: 0,
                      height: "auto", // Allow height to grow infinitely
                    }}
                  >
                    <Table>
                      <TableHead style={{ height: 34 }}>
                        <TableRow
                          style={{
                            background: InstaColors.primary,
                            alignItems: "center",
                            height: "34px",
                            borderRadius: 0,

                            width: "100%",
                            marginTop: 10,
                            textTransform: "none",
                          }}
                        >
                          {extractedColumnNames.map((column) => (
                            <TableCell
                              key={column.field}
                              align="center"
                              style={{
                                color: "white",
                                fontFamily: fontFamily, // Add this line
                                fontSize: 13,
                                padding: 6,
                                whiteSpace: "nowrap",

                                fontWeight: 500,
                                borderBottom: "none",
                                borderTop: "none",
                              }}
                            >
                              {column.header}
                            </TableCell>
                          ))}
                          <TableCell
                            align="center"
                            style={{
                              borderBottom: "none",
                              borderTop: "none",
                              whiteSpace: "nowrap",
                            }}
                          ></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {extractionRows.map((row, index) => (
                          <TableRow
                            key={row.fileImportId}
                            className="extractcolumnRowStyle"
                            // style={{ borderBottom: '1px solid #e0e0e0', borderTop: 'none', height: '34px', whiteSpace: "nowrap", }}
                          >
                            {extractedColumnNames.map((column) => (
                              <TableCell
                                key={column.field}
                                align="left"
                                // align="center"
                                style={{
                                  color: "black",
                                  fontSize: 10,
                                  fontFamily: fontFamily, // Add this line
                                  fontWeight: 300,
                                  fontSize: 12,
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                  borderBottom: "none",
                                  borderTop: "none",
                                  padding: "4px 16px",
                                }}
                                // onClick={() => { if (iSEdit !== true) { handleEditClick(row, column.field, index) } }}
                              >
                                {row[column.field]}
                              </TableCell>
                            ))}
                            {/* <TableCell align="center" style={{ borderBottom: 'none', borderTop: 'none', padding: '4px 16px' }}>
                                                        {iSEdit !== true && (
                                                            <DeleteButton onClick={() => handleDeleteClickRow(index)} />
                                                        )}

                                                    </TableCell> */}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {(isDisplayView === false || selectedView !== "Extraction") && (
        <div
          style={{
            width: isMenuOpen === true ? "calc(100vw - 280px)" : "calc(100vw - 128px)",
            // background: InstaColors.white,
            overflowX: "hidden",
            borderRadius: 11,
            display: "flex",
            flexDirection: "row",
            marginTop: 10,
            height: isExpanded ? "100%" : "50%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              color: InstaColors.white,
              width: "100%",
              height: "100%",
              marginTop: "0px",
            }}
          >
            {(isDisplayView === false || selectedView === "Visualization") && (
              <div
                style={{
                  width: isExpanded ? "100%" : "50%",
                  flexDirection: "column",
                  display: "flex",
                  justifyContent: "center",
                  height: "100%",
                  alignItems: "center",
                  overflow: "auto",
                  marginRight: 10,
                }}
              >
                {someValue === row.fileImportId && activeView.visualize === true && (
                  <div
                    style={{
                      background: "white",
                      width: "100%",
                      height: "100%",
                      padding: 20,
                      borderRadius: 6,
                      overflow: "hidden",
                      // display: 'flex',
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          color: "black",
                          fontWeight: 500,
                          fontFamily: fontFamily,
                          fontSize: 15,
                          marginRight: "auto",
                        }}
                      >
                        Visualization View
                      </span>
                      <div title="Update View">
                        <select
                          id="orientation-select"
                          // value={}
                          onChange={handleUpdateView}
                          style={{
                            padding: "0px",
                            borderRadius: "4px",
                            height: "32px",
                            display: "flex",

                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #ccc",
                            marginRight: 6,
                          }}
                        >
                          <option value="vertical">Vertical</option>
                          <option value="horizontal">Horizontal</option>
                          <option value="inversion">Inversion</option>
                        </select>
                        {/* <ViewModuleIcon onClick={
                                                handleUpdateView
                                            } style={{ color: InstaColors.primary, cursor: 'pointer', marginRight: 6, marginBottom: 3 }} /> */}
                      </div>
                      {isExpanded === true ? (
                        <CloseIcon
                          style={{
                            fontSize: 24,
                            color: InstaColors.primary,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setIsExpanded(false);
                            setSelectedView(null);
                            setIsDisplayView(false);
                          }}
                        />
                      ) : (
                        <ExpandButton
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setIsExpanded(true);
                            setSelectedView("Visualization");
                            setIsDisplayView(true);
                          }}
                        />
                      )}
                      {/* <img src="/Move.png" onClick={() => { }} alt="Move" style={{ height: 20, marginLeft: 'auto', marginRight: 10 }} /> */}
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        overflow: "auto",
                        width: "100%",
                        justifyContent: "center",
                        height: "100%",
                        background: "white",
                        padding: 40,
                        borderRadius: 6,
                      }}
                    >
                      {treeData.length > 0 && <OrganizationChartManager data={treeData} />}
                    </div>
                  </div>
                )}
              </div>
            )}

            {(isDisplayView === false || selectedView === "Original") && (
              <div
                style={{
                  width: isExpanded ? "100%" : "50%",
                  flexDirection: "column",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "start",
                  overflowX: "auto",
                  padding: 20,
                  background: "white",
                  borderRadius: 6,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "space-between",
                    width: "100%",
                  }}
                >
                  <span
                    style={{
                      color: "black",
                      fontWeight: 500,
                      fontSize: 15,
                      fontFamily: fontFamily,
                      marginRight: "auto",
                    }}
                  >
                    Original View
                  </span>

                  {isExpanded === true ? (
                    <CloseIcon
                      style={{
                        fontSize: 24,
                        color: InstaColors.primary,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setIsExpanded(false);
                        setSelectedView(null);
                        setIsDisplayView(false);
                      }}
                    />
                  ) : (
                    <ExpandButton
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setIsExpanded(true);
                        setSelectedView("Original");
                        setIsDisplayView(true);
                      }}
                    />
                  )}
                </div>
                {isExpanded && <div style={{ marginBottom: 20 }}></div>}
                {someValue === row.fileImportId && activeView.original === true && (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      background: "#666362",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        height: "100vh",
                        width: "100%",
                        overflow: "hidden",
                      }}
                    >
                      {/* Embedded PDF */}
                      <SecureDocumentViewer
                        organizationId={getUserIdFromLocalStorage()?.organizationId}
                        userId={getUserIdFromLocalStorage()?.userId}
                        fileImportId={row?.fileImportId}
                        fileName={row?.fileName}
                        style={{ width: "100%", height: "100%" }}
                        fileType={row.uploadType === 1 ? "uploadfiles" : "uploadfiles"}
                        extension={row?.fileName.split(".")[1] || ""}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {isLoading && <LoadingOverlay />}
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        aria-labelledby="add-administrator-modal-title"
        aria-describedby="add-administrator-modal-description"
      >
        <div
          style={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            position: "absolute",
            width: "450px", // Width changed to 500px
            padding: "20px",
            outline: "none",
            backgroundColor: "white",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
          }}
        >
          <h6 style={{ color: "#2aa7e0", fontFamily: fontFamily }}>UPDATE DATA</h6>
          <div
            style={{
              height: "1px",
              width: "410px",
              backgroundColor: "#2aa7e0",
              marginBottom: "20px",
              marginRight: "10px",
            }}
          ></div>

          <div>
            {/* Adjusting height of text boxes */}
            <div style={{ marginBottom: "20px" }}>
              <span
                style={{
                  color: "black",
                  display: "inline-block",
                  width: "100px",
                  fontFamily: fontFamily,
                }}
              >
                {columnName}
              </span>
              <TextField
                value={editValue}
                sx={borderStyle}
                onChange={(e) => setEditValue(e.target.value)}
                variant="outlined"
                inputProps={{ style: { padding: "2px 0 2px 6px" } }}
                style={{
                  marginLeft: "20px",
                  backgroundColor: "white",
                  border: "0px",
                }}
                disabled={false}
              ></TextField>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              {/* Adjusting button styles as per requirements */}
              <Button
                variant="contained"
                style={reviewScreenButtonWithOutColor(100)}
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                style={reviewScreenButtonWithColor(80)}
                onClick={() => {
                  handleSave();
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
